/**
 * PriceTag Atom Component
 * Displays pricing information with currency formatting
 */

import { cn } from '@/lib/utils'

interface PriceTagProps {
	amount: number
	currency?: string
	period?: 'day' | 'week' | 'month'
	size?: 'sm' | 'md' | 'lg'
	className?: string
}

const sizeClasses = {
	sm: 'text-sm',
	md: 'text-lg font-semibold',
	lg: 'text-2xl font-bold',
}

export function PriceTag({
	amount,
	currency = 'USD',
	period = 'day',
	size = 'md',
	className,
}: PriceTagProps) {
	const formattedPrice = new Intl.NumberFormat('es-MX', {
		style: 'currency',
		currency: currency,
	}).format(amount)

	const periodLabel = {
		day: 'día',
		week: 'semana',
		month: 'mes',
	}[period]

	return (
		<div className={cn('flex items-baseline gap-1', className)}>
			<span className={cn('text-[#09194D]', sizeClasses[size])}>
				{formattedPrice}
			</span>
			<span className='text-sm text-gray-600'>/ {periodLabel}</span>
		</div>
	)
}
